module.exports = __webpack_public_path__ + "img/forgot-password-v2.889a8539.svg";